export function getObject(key) {
    let val = sessionStorage.getItem(key)
    if (val == null) return {}
    return JSON.parse(val)
}

export function setObject(key, val) {
    sessionStorage.setItem(key, JSON.stringify(val))
}
